import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScalaDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 59,
	viewBox: "0 0 58 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.6995 26.1057V26.2144C13.6972 26.1782 13.6972 26.1419 13.6995 26.1057Z",
			fill: "#8C8C8C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.2103 7.91874C31.0903 9.97599 19.7947 11.137 13.709 11.137V22.7585C13.7109 22.7985 13.726 22.8367 13.752 22.8671C17.9049 22.8671 30.7259 21.5092 38.4615 19.3818C39.8106 19.0384 41.1335 18.599 42.4199 18.0669C43.3659 17.6414 43.9769 17.1933 43.9769 16.7271V5.00601C43.9679 6.11045 41.0914 7.08815 38.2103 7.91874Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.2103 22.9893C33.9487 24.2183 28.198 25.1326 22.9587 25.6667C19.4417 26.0266 16.1555 26.2144 13.709 26.2144V37.8268C13.7109 37.8668 13.726 37.905 13.752 37.9355C17.9049 37.9355 30.7259 36.5776 38.4615 34.4524C39.8104 34.108 41.1331 33.6686 42.4199 33.1375C43.3659 32.7098 43.9769 32.2639 43.9769 31.7977V20.0766C43.9679 21.1788 41.0914 22.1565 38.2103 22.9893Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.2111 38.0689C33.9495 39.2978 28.1987 40.2099 22.9594 40.7463C19.4379 41.1061 16.1472 41.294 13.7007 41.294V53.006C17.8106 53.006 30.6973 51.6594 38.4532 49.523C41.3117 48.7354 43.9686 47.8391 43.9686 46.866V35.1449C43.9686 36.2584 41.0921 37.227 38.2111 38.0689Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgScalaDark);
export { ForwardRef as ReactComponent };
